<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div v-if="!isLoaded" class="col-lg-12">
                <LoadingScreen :message="'Cargando Información de los Colaboradores del Proyecto'" />
            </div>
            <div v-if="isLoaded" class="col-lg-12">
                <!-- Header Card -->
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 class="mb-1">Colaboradores del Proyecto: {{ projectInfo.identifier }} - {{ projectInfo.project }}</h5>
                                <h6 class="text-sm text-muted mb-0">Cliente: {{ projectInfo.client }}</h6>
                            </div>
                            <button class="btn btn-warning mb-0" @click="goBack">
                                <i class="fas fa-arrow-left me-2"></i>Volver
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Sección Agregar Usuarios -->
                    <div class="col-lg-5 mb-4">
                        <div class="card h-100">
                            <div class="card-header pb-0">
                                <h6>Agregar Colaboradores</h6>
                            </div>
                            <div class="card-body">
                                <!-- Alerta para reportes automáticos -->
                                <div v-if="automaticReports" class="alert alert-info" role="alert">
                                    <strong>Reportes Automáticos Activos</strong>
                                    <p class="mb-0 text-sm">Configura las fechas para la generación automática de
                                        reportes.</p>
                                </div>

                                <!-- Fechas para reportes automáticos -->
                                <div v-if="automaticReports" class="mb-4">
                                    <div class="row">
                                        <div class="col-6">
                                            <label class="form-label">Fecha Inicio</label>
                                            <input v-model="startDate" type="date" class="form-control" required>
                                        </div>
                                        <div class="col-6">
                                            <label class="form-label">Fecha Fin</label>
                                            <input v-model="endDate" type="date" class="form-control" required>
                                        </div>
                                    </div>
                                </div>

                                <!-- Buscador de usuarios -->
                                <div class="mb-3">
                                    <label class="form-label">Buscar colaborador</label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="fas fa-search"></i>
                                        </span>
                                        <input type="text" class="form-control" v-model="searchQuery"
                                            @input="searchUsers" placeholder="Escribe nombre o apellido...">
                                    </div>
                                </div>

                                <!-- Lista de sugerencias -->
                                <div v-if="filteredUsers.length" class="mb-3">
                                    <div class="list-group" style="max-height: 200px; overflow-y: auto;">
                                        <button v-for="user in filteredUsers" :key="user.user_id" type="button"
                                            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                            @click="addUser(user)">
                                            <span>{{ user.name }} {{ user.last_name }}</span>
                                            <i class="fas fa-plus text-warning"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- Usuarios seleccionados para agregar -->
                                <div v-if="selectedUsers.length" class="mt-4">
                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                        <h6 class="mb-0">Pendientes de agregar ({{ selectedUsers.length }})</h6>
                                        <button class="btn btn-sm btn-outline-danger" @click="clearSelection">
                                            Limpiar todo
                                        </button>
                                    </div>

                                    <div class="list-group mb-3">
                                        <div v-for="user in selectedUsers" :key="user.user_id" class="list-group-item">
                                            <div class="d-flex justify-content-between align-items-center mb-2">
                                                <span class="fw-bold">{{ user.name }} {{ user.last_name }}</span>
                                                <button class="btn btn-sm btn-outline-danger" @click="removeUser(user)">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <label class="form-label mb-0 me-2 text-sm">Factor de Cobranza:</label>
                                                <input v-model="user.billing_factor" type="text" inputmode="decimal"
                                                    pattern="^\d+(\.\d{0,2})?$" class="form-control form-control-sm"
                                                    placeholder="1.0" style="width: 80px;">
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" class="btn btn-warning w-100" @click="handleSubmit">
                                        <i class="fas fa-save me-2"></i>Agregar Colaboradores
                                    </button>
                                </div>

                                <!-- Mensaje cuando no hay selección -->
                                <div v-else class="text-center py-4">
                                    <i class="fas fa-user-plus fa-3x text-muted mb-3"></i>
                                    <p class="text-muted mb-0">No hay colaboradores seleccionados</p>
                                    <p class="text-sm text-muted">Usa el buscador para encontrar y agregar colaboradores
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Sección Usuarios Actuales -->
                    <div class="col-lg-7 mb-4">
                        <div class="card h-100">
                            <div class="card-header pb-0">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6>Colaboradores Actuales</h6>
                                    <span class="badge bg-warning">{{ project_users.length }} colaboradores</span>
                                </div>
                            </div>
                            <div class="card-body">
                                <!-- Buscador de tabla -->
                                <div v-if="project_users.length" class="mb-3">
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="fas fa-search"></i>
                                        </span>
                                        <input type="text" class="form-control" v-model="tableSearchQuery"
                                            placeholder="Buscar en la tabla...">
                                    </div>
                                </div>

                                <!-- Tabla de usuarios actuales -->
                                <div v-if="filteredProjectUsers.length" class="table-responsive">
                                    <table class="table table-hover align-items-center">
                                        <thead>
                                            <tr>
                                                <th
                                                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                                    Colaborador
                                                </th>
                                                <th
                                                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                                    Acciones
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="user in paginatedUsers" :key="user.user_id">
                                                <td>
                                                    <div class="d-flex px-2 py-1">
                                                        <div class="d-flex flex-column justify-content-center">
                                                            <h6 class="mb-0 text-sm">{{ user.name }} {{ user.last_name
                                                            }}</h6>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="align-middle text-center">
                                                    <button type="button" class="btn btn-sm btn-danger mb-0"
                                                        @click="confirmRemoveUser(user)">
                                                        <i class="fas fa-trash me-1"></i>Eliminar
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <!-- Paginación -->
                                    <div v-if="totalPages > 1"
                                        class="d-flex justify-content-between align-items-center mt-3">
                                        <div class="text-sm text-muted">
                                            Mostrando {{ startIndex + 1 }} a {{ endIndex }} de {{
                                                filteredProjectUsers.length }} registros
                                        </div>
                                        <div class="d-flex gap-2">
                                            <button class="btn btn-sm btn-outline-secondary" @click="currentPage--"
                                                :disabled="currentPage === 1">
                                                <i class="fas fa-chevron-left"></i>
                                            </button>
                                            <span class="align-self-center text-sm mx-2">
                                                Página {{ currentPage }} de {{ totalPages }}
                                            </span>
                                            <button class="btn btn-sm btn-outline-secondary" @click="currentPage++"
                                                :disabled="currentPage === totalPages">
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                        </div>
                                        <div>
                                            <select v-model="itemsPerPage" class="form-select form-select-sm"
                                                style="width: auto;" @change="currentPage = 1">
                                                <option :value="5">5 por página</option>
                                                <option :value="10">10 por página</option>
                                                <option :value="25">25 por página</option>
                                                <option :value="50">50 por página</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <!-- Mensaje cuando no hay resultados de búsqueda -->
                                <div v-else-if="project_users.length && !filteredProjectUsers.length"
                                    class="text-center py-5">
                                    <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                    <p class="text-muted mb-0">No se encontraron resultados</p>
                                    <p class="text-sm text-muted">Intenta con otro término de búsqueda</p>
                                </div>

                                <!-- Mensaje cuando no hay usuarios -->
                                <div v-else class="text-center py-5">
                                    <i class="fas fa-users-slash fa-3x text-muted mb-3"></i>
                                    <p class="text-muted mb-0">No hay colaboradores asignados</p>
                                    <p class="text-sm text-muted">Agrega colaboradores usando el panel de la izquierda
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import LoadingScreen from "./components/LoadingScreen.vue";
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';

const route = useRoute();
const router = useRouter();
const token = localStorage.getItem('authToken');
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const project_id = ref(route.params.id);

const found = ref(true)
const isLoaded = ref(false)

if (!project_id.value) { found.value = false }

const projectInfo = ref({})

const searchQuery = ref("");
const all_users = ref([]);
const filteredUsers = ref([]);
const selectedUsers = ref([]);
const automaticReports = ref(false);
const startDate = ref("");
const endDate = ref("");
const project_users = ref([]);

// Para la tabla
const tableSearchQuery = ref("");
const currentPage = ref(1);
const itemsPerPage = ref(10);


// Filtrar usuarios de la tabla según búsqueda
const filteredProjectUsers = computed(() => {
    if (!tableSearchQuery.value) {
        return project_users.value;
    }

    const query = tableSearchQuery.value.toLowerCase();
    return project_users.value.filter(user => {
        const fullName = `${user.name} ${user.last_name}`.toLowerCase();
        return fullName.includes(query);
    });
});

// Calcular total de páginas
const totalPages = computed(() => {
    return Math.ceil(filteredProjectUsers.value.length / itemsPerPage.value);
});

// Calcular índice inicial y final
const startIndex = computed(() => {
    return (currentPage.value - 1) * itemsPerPage.value;
});

const endIndex = computed(() => {
    const end = startIndex.value + itemsPerPage.value;
    return Math.min(end, filteredProjectUsers.value.length);
});

// Usuarios paginados
const paginatedUsers = computed(() => {
    return filteredProjectUsers.value.slice(startIndex.value, endIndex.value);
});


// Obtener detalles del proyecto (fallback si no están en state)
const getProjectInfo = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/project-info`, { project_id: project_id.value }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        projectInfo.value = response.data
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
};

// Volver a la lista de proyectos
const goBack = () => {
    router.push({ name: 'projects-list' });
};

// Limpiar selección
const clearSelection = () => {
    selectedUsers.value = [];
};

// Buscar colaboradores para agregar
const searchUsers = async () => {
    if (searchQuery.value.length < 2) {
        filteredUsers.value = [];
        return;
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/search-users`,
            { query: searchQuery.value, project_id: project_id.value },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        all_users.value = response.data;
        filteredUsers.value = all_users.value;
    } catch (error) {
        console.error("Error al buscar usuarios:", error);
    }
};

// Agregar colaborador a la lista de pendientes
const addUser = (user) => {
    if (!selectedUsers.value.some(u => u.user_id === user.user_id)) {
        selectedUsers.value.push({ ...user, billing_factor: 1 });
    }
    searchQuery.value = "";
    filteredUsers.value = [];
};

// Remover colaborador de la lista de pendientes
const removeUser = (user) => {
    selectedUsers.value = selectedUsers.value.filter(u => u.user_id !== user.user_id);
};

// Confirmar eliminación de usuario del proyecto
const confirmRemoveUser = (user) => {
    if (confirm(`¿Estás segur@ de remover a ${user.name} ${user.last_name} del proyecto?`)) {
        removeUserFromProject(user.user_id);
    }
};

// Remover usuario del proyecto
const removeUserFromProject = async (user_id) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/remove-user-from-project`,
            {
                project_id: project_id.value,
                user_id: user_id
            },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        if (response.status === 200) {
            alert("Usuario removido del proyecto");
            await fetchProjectUsers();
        }
    } catch (error) {
        console.error("Error al remover el usuario:", error);
        alert("Ocurrió un error al remover el usuario.");
    }
};

// Guardar usuarios seleccionados
const handleSubmit = async () => {
    if (selectedUsers.value.length === 0) {
        alert("Debes agregar al menos un colaborador antes de guardar.");
        return;
    }

    const selectedUsersIds = selectedUsers.value.map(user => ({
        user_id: user.user_id,
        billing_factor: user.billing_factor ?? 1
    }));

    try {
        const response = await axios.post(`${API_BASE_URL}/add-users-to-project`,
            {
                project_id: project_id.value,
                selected_users: selectedUsersIds,
                start_date: startDate.value,
                end_date: endDate.value,
            },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        if (response.status === 200) {
            alert("Usuario(s) Agregado(s)");
            selectedUsers.value = [];
            await fetchProjectUsers();
        }
    } catch (error) {
        console.error("Error al agregar usuarios:", error);
        alert("Ocurrió un error al agregar usuarios.");
    }
};

// Obtener usuarios del proyecto
const fetchProjectUsers = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/project-users`,
            { project_id: project_id.value },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        project_users.value = response.data;
        // Resetear a la primera página después de actualizar
        currentPage.value = 1;
    } catch (error) {
        console.error('Error al obtener los datos de usuarios:', error);
    }
};

// Verificar estado de reportes automáticos
const checkARStatus = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/project-ar-status`,
            { project_id: project_id.value },
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );
        automaticReports.value = response.data[0].automatic_reports;
    } catch (error) {
        console.error('Error al obtener el estado de reportes automáticos:', error);
    }
};

const getData = async () => {
    await getProjectInfo();
    await fetchProjectUsers();
    await checkARStatus();

    isLoaded.value = true
}

// Montar componente
onMounted(async () => {
    await getData();
});
</script>

<style scoped>
.card {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.list-group-item-action:hover {
    background-color: #f8f9fa;
}

.table> :not(caption)>*>* {
    padding: 0.75rem 0.5rem;
}

.alert-info {
    background-color: #e7f3ff;
    border-color: #b3d9ff;
    color: #004085;
}

.btn:disabled {
    cursor: not-allowed;
    opacity: 0.65;
}

.gap-2 {
    gap: 0.5rem;
}
</style>